module.exports = __webpack_public_path__ + "media/images/creator/home/about-01@2x-4241d9ee903280697cc89e87bf222652.png";